module.exports = __webpack_public_path__ + "static/3-Tri-14-5ba36f09d6aa0bbdb58e1cded144db84.png";